import axios, { AxiosRequestConfig } from "axios";
import userStore from "@/store/userStore";

export function configureAuthHeaderInterceptor() {
  axios.interceptors.request.use(async (axiosConfig: AxiosRequestConfig) => {
    const user = await userStore.userPromise;

    if (!user) {
      throw new Error("User is null");
    }

    const token = user.access_token;

    if (!token || token === "") {
      throw new Error("Token is null");
    }

    if (axiosConfig.url) {
      axiosConfig.headers.Authorization = `Bearer ${token}`;
    }
    return axiosConfig;
  });
}
